module.exports = __webpack_public_path__ + "static/media/special_item_list.fd7e7504.csv";


//////////////////
// WEBPACK FOOTER
// ./src/data/special/special_item_list.csv
// module id = 745
// module chunks = 0